// Listings redesign (DR-81…DR-88) · admin surface strings. Spread into en.ts; the bn twin is
// lr-admin-bn.ts. Keys are namespaced `lr.admin.*`.
export const lrAdminEn = {
  // ---- Business 360 · Edit profile (FR-A28, API-265) ----
  'lr.admin.profile.edit': 'Edit profile',
  'lr.admin.profile.title': 'Edit profile',
  'lr.admin.profile.sub': 'Every public fact of this listing. Only the fields you change are saved; the merchant and the import keep the rest.',
  'lr.admin.profile.back': '← Back to the 360',
  'lr.admin.profile.save': 'Save changes',
  'lr.admin.profile.saving': 'Saving…',
  'lr.admin.profile.saved': 'Profile saved: {fields}',
  'lr.admin.profile.nothing': 'Nothing has changed.',
  'lr.admin.profile.failed': 'The profile could not be saved.',
  'lr.admin.profile.lock.banner': 'Imported listing — fields you edit here are locked against re-import until the owner claims it.',
  'lr.admin.profile.lock.list': 'Locked against the import: {fields}',
  'lr.admin.profile.lock.none': 'No field is locked against the import.',
  'lr.admin.profile.lock.clear': 'Clear locks',
  'lr.admin.profile.lock.cleared': 'The import locks were cleared.',
  'lr.admin.profile.sec.identity': 'Identity',
  'lr.admin.profile.sec.place': 'Location & contact',
  'lr.admin.profile.sec.about': 'About',
  'lr.admin.profile.sec.amenities': 'Amenities',
  'lr.admin.profile.sec.links': 'Links & video',
  'lr.admin.profile.sec.nearby': "What's nearby",
  'lr.admin.profile.sec.meta': 'Category information',
  'lr.admin.profile.sec.hours': 'Opening hours',
  'lr.admin.profile.sec.policies': 'Booking policies',
  'lr.admin.profile.f.name': 'Name (English)',
  'lr.admin.profile.f.name_bn': 'Name (Bangla)',
  'lr.admin.profile.f.category': 'Category',
  'lr.admin.profile.f.subcategory': 'Specialty',
  'lr.admin.profile.f.subcategory_other': 'Specialty (other)',
  'lr.admin.profile.f.area': 'Area',
  'lr.admin.profile.f.address': 'Address',
  'lr.admin.profile.f.lat': 'Latitude',
  'lr.admin.profile.f.lng': 'Longitude',
  'lr.admin.profile.f.map_link': 'Map link',
  'lr.admin.profile.f.phone': 'Phone',
  'lr.admin.profile.f.email': 'Email',
  'lr.admin.profile.f.about_en': 'About (English)',
  'lr.admin.profile.f.about_bn': 'About (Bangla)',
  'lr.admin.profile.f.video_url': 'Showcase video',
  'lr.admin.profile.f.policy_text': 'Policy notes',
  'lr.admin.profile.f.cancellation': 'Cancellation tier',
  'lr.admin.profile.f.advance': 'Advance (%)',
  'lr.admin.profile.f.instant': 'Instant confirmation',
  'lr.admin.profile.pick': 'Choose…',
  'lr.admin.profile.amenities.none': 'This category has no amenity vocabulary yet — add one under Categories.',
  'lr.admin.profile.amenities.count': '{n} selected',
  'lr.admin.profile.social.website': 'Website',
  'lr.admin.profile.social.facebook': 'Facebook',
  'lr.admin.profile.social.instagram': 'Instagram',
  'lr.admin.profile.social.youtube': 'YouTube',
  'lr.admin.profile.social.whatsapp': 'WhatsApp link',
  'lr.admin.profile.nearby.hint': 'Up to six places, nearest first. Transit stops and markets within 500 m make the listing "walkable".',
  'lr.admin.profile.nearby.name': 'Place',
  'lr.admin.profile.nearby.kind': 'Kind',
  'lr.admin.profile.nearby.distance': 'Distance (m)',
  'lr.admin.profile.nearby.add': '＋ Add a place',
  'lr.admin.profile.nearby.remove': 'Remove place {name}',
  'lr.admin.profile.hours.closed': 'Closed',
  'lr.admin.profile.hours.open': 'Opens',
  'lr.admin.profile.hours.close': 'Closes',
  'lr.admin.profile.hours.hint': 'A close past midnight keeps counting ("25:30").',
  'lr.admin.profile.meta.none': 'This category has no extra information fields.',
  'lr.admin.profile.err.name': 'A name is required.',
  'lr.admin.profile.err.address': 'An address is required.',
  'lr.admin.profile.err.phone': 'Enter a valid phone number.',
  'lr.admin.profile.err.pin': 'Latitude and longitude must both be set and in range.',
  'lr.admin.profile.err.advance': 'The advance is a whole number from 0 to 100.',
  'lr.admin.profile.err.url': 'Links must start with http:// or https://.',
  'lr.admin.profile.err.nearby_max': 'At most six nearby places.',
  'lr.admin.profile.err.nearby_row': 'Every nearby place needs a name and a distance in metres.',
  'lr.admin.profile.err.hours': 'Opening hours must be HH:MM on every open day.',
  // nearby kinds
  'lr.admin.nearby.transit': 'Transit',
  'lr.admin.nearby.market': 'Market',
  'lr.admin.nearby.health': 'Hospital / clinic',
  'lr.admin.nearby.landmark': 'Landmark',
  'lr.admin.nearby.mosque': 'Mosque',
  'lr.admin.nearby.attraction': 'Attraction',
  'lr.admin.nearby.shopping': 'Shopping',
  'lr.admin.nearby.beach': 'Beach',
  'lr.admin.nearby.park': 'Park',
  'lr.admin.nearby.food': 'Food',
  'lr.admin.nearby.other': 'Other',
  // weekdays (0 = Sunday)
  'lr.admin.day.0': 'Sunday',
  'lr.admin.day.1': 'Monday',
  'lr.admin.day.2': 'Tuesday',
  'lr.admin.day.3': 'Wednesday',
  'lr.admin.day.4': 'Thursday',
  'lr.admin.day.5': 'Friday',
  'lr.admin.day.6': 'Saturday',
  // ---- category information (DB-103) ----
  'lr.admin.meta.hotel.check_in': 'Check-in',
  'lr.admin.meta.hotel.check_out': 'Check-out',
  'lr.admin.meta.hotel.floors': 'Floors',
  'lr.admin.meta.hotel.rooms_total': 'Rooms in total',
  'lr.admin.meta.restaurant.cuisine': 'Cuisines (comma separated)',
  'lr.admin.meta.restaurant.seating': 'Seats',
  'lr.admin.meta.restaurant.reservation_note': 'Reservation note',
  'lr.admin.meta.turf.facts': 'Pitch facts',
  'lr.admin.meta.turf.ramadan': 'Ramadan schedule',
  'lr.admin.meta.turf.bonus': 'Bonus line',
  'lr.admin.meta.turf.who': 'Who can play',
  'lr.admin.meta.turf.rules': 'Ground rules',
  'lr.admin.meta.turf.packages': 'Packages',
  'lr.admin.meta.turf.getting_there': 'How to get there',
  'lr.admin.meta.turf.pay': 'Booking & payment rules',
  'lr.admin.meta.pay.title': 'Heading (English)',
  'lr.admin.meta.pay.text': 'Rule (English)',
  'lr.admin.meta.pay.advance': 'Advance & balance',
  'lr.admin.meta.pay.confirmation': 'Confirmation',
  'lr.admin.meta.pay.cancel': 'Cancel & reschedule',
  'lr.admin.meta.pay.rain': 'If it rains',
  'lr.admin.meta.pay.other': 'Other',
  'lr.admin.catx.am.filterable': 'Filter chip',
  'lr.admin.catx.am.filterable_hint': 'Show this amenity as a chip in the results page filter.',
  'lr.admin.meta.turf.faq': 'Common questions',
  'lr.admin.meta.turf.not_available': 'Not available here',
  'lr.admin.meta.en': 'English',
  'lr.admin.meta.bn': 'Bangla',
  'lr.admin.meta.key': 'Key',
  'lr.admin.meta.title': 'Title',
  'lr.admin.meta.detail': 'Detail',
  'lr.admin.meta.price_label': 'Price label',
  'lr.admin.meta.question': 'Question',
  'lr.admin.meta.answer': 'Answer',
  'lr.admin.meta.allowed': 'Allowed',
  'lr.admin.meta.not_allowed': 'Not allowed',
  'lr.admin.meta.add': '＋ Add row',
  'lr.admin.meta.remove': 'Remove row',
  'lr.admin.meta.fact.format': 'Format',
  'lr.admin.meta.fact.pitch_size': 'Pitch size',
  'lr.admin.meta.fact.surface': 'Surface',
  'lr.admin.meta.fact.setting': 'Setting',
  'lr.admin.meta.fact.lights': 'Lights',
  'lr.admin.meta.fact.power': 'Power',
  'lr.admin.meta.fact.open': 'Open',
  'lr.admin.meta.who.general': 'General booking',
  'lr.admin.meta.who.women': 'Women-only slots',
  'lr.admin.meta.who.family': 'Family slot',
  'lr.admin.meta.who.kids': 'Kids academy',
  'lr.admin.meta.pack.tournament': 'Tournament',
  'lr.admin.meta.pack.corporate': 'Corporate match',
  'lr.admin.meta.pack.monthly': 'Monthly fixed slot',
  'lr.admin.meta.pack.play_eat': 'Play + eat',
  'lr.admin.meta.pack.other': 'Other',
  'lr.admin.meta.go.address': 'Address',
  'lr.admin.meta.go.landmark': 'Landmark',
  'lr.admin.meta.go.transit': 'Nearest stop',
  'lr.admin.meta.go.rickshaw': 'By rickshaw',
  'lr.admin.meta.go.parking': 'Parking',
  // ---- photos (API-265 / API-225) ----
  'lr.admin.photos.title': 'Photos',
  'lr.admin.photos.hint': 'Up to {n} photos; the first is the cover. Drag with the arrows.',
  'lr.admin.photos.add': '＋ Add photos',
  'lr.admin.photos.cover': 'Cover',
  'lr.admin.photos.up': 'Move up',
  'lr.admin.photos.down': 'Move down',
  'lr.admin.photos.remove': 'Remove',
  'lr.admin.photos.save': 'Save gallery',
  'lr.admin.photos.saved': 'Gallery saved ({n} photos).',
  'lr.admin.photos.failed': 'The gallery could not be saved.',
  'lr.admin.photos.too_many': 'A listing has at most {n} photos.',
  'lr.admin.photos.upload_failed': 'A photo could not be uploaded.',
  'lr.admin.photos.empty': 'No photos yet — the public page shows placeholder tiles.',
  // ---- trust: certificates (API-266) ----
  'lr.admin.cert.title': 'Certificates',
  'lr.admin.cert.sub': 'What the public sees per kind: on file, expired or none. Documents stay private.',
  'lr.admin.cert.add': '＋ File a certificate',
  'lr.admin.cert.kind': 'Kind',
  'lr.admin.cert.expires': 'Expires',
  'lr.admin.cert.file': 'Document (optional)',
  'lr.admin.cert.filed': 'Certificate filed as verified.',
  'lr.admin.cert.deleted': 'Certificate removed.',
  'lr.admin.cert.delete': 'Remove',
  'lr.admin.cert.delete_title': 'Remove the {kind} certificate?',
  'lr.admin.cert.delete_body': 'The public page will show it as not on file. The document is deleted.',
  'lr.admin.cert.view': 'View document',
  'lr.admin.cert.failed': 'The certificate could not be saved.',
  'lr.admin.cert.state.pending': 'Pending review',
  'lr.admin.cert.state.ok': 'On file',
  'lr.admin.cert.state.rejected': 'Rejected',
  'lr.admin.cert.state.expired': 'Expired',
  'lr.admin.cert.state.none': 'Not on file',
  'lr.admin.cert.err.date': 'The expiry must be a date on or after today.',
  'lr.admin.cert.err.kind': 'Pick a certificate kind.',
  'lr.admin.cert.issuer': 'Issued by {issuer}',
  'lr.admin.cert.submitted': 'Submitted {date}',
  'lr.admin.cert.submitted_label': 'Submitted',
  'lr.admin.cert.by': 'by {name}',
  'lr.admin.cert.reason': 'Reason: {reason}',
  // Approvals › Certificates tab
  'lr.admin.approvals.tab.certificates': 'Certificates ({n})',
  'lr.admin.approvals.hero.certificates': 'Certificates',
  'lr.admin.approvals.search.certificates': 'Search certificates by business or kind',
  'lr.admin.approvals.meta.certificate': '{kind} · {category} · claimed expiry {date}',
  'lr.admin.approvals.cert.panel': 'Certificate review',
  'lr.admin.approvals.cert.verify': 'Verify',
  'lr.admin.approvals.cert.verify_title': 'Verify the {kind} certificate of {name}?',
  'lr.admin.approvals.cert.verify_body': 'Confirm the expiry date you read on the document. The public page shows "on file" until then.',
  'lr.admin.approvals.cert.verify_action': 'Verify certificate',
  'lr.admin.approvals.cert.reject': 'Reject',
  'lr.admin.approvals.cert.reject_title': 'Reject the {kind} certificate of {name}',
  'lr.admin.approvals.cert.reject_hint': 'The merchant sees this reason word for word.',
  'lr.admin.approvals.cert.reject_ph': 'e.g. The document is unreadable, or it names another branch.',
  'lr.admin.approvals.cert.reject_send': 'Send rejection',
  'lr.admin.approvals.cert.reason_required': 'A reason is required.',
  'lr.admin.approvals.cert.verified': '{kind} verified for {name}.',
  'lr.admin.approvals.cert.rejected': '{kind} rejected for {name}.',
  'lr.admin.approvals.cert.open_360': 'Open the business →',
  'lr.admin.approvals.cert.state_filter': 'State',
  'lr.admin.approvals.cert.state.pending': 'Pending',
  'lr.admin.approvals.cert.state.ok': 'Verified',
  'lr.admin.approvals.cert.state.rejected': 'Rejected',
  'lr.admin.approvals.cert.state.expired': 'Expired',
  // ---- trust: inspections (API-267) ----
  'lr.admin.insp.title': 'Inspection reports',
  'lr.admin.insp.sub': 'A published, unexpired report shows on the public page with the Inspected badge.',
  'lr.admin.insp.new': '＋ Write a report',
  'lr.admin.insp.edit': 'Edit',
  'lr.admin.insp.publish': 'Publish',
  'lr.admin.insp.withdraw': 'Withdraw',
  'lr.admin.insp.published': 'Report published.',
  'lr.admin.insp.withdrawn': 'Report withdrawn.',
  'lr.admin.insp.saved': 'Report saved.',
  'lr.admin.insp.failed': 'The report could not be saved.',
  'lr.admin.insp.withdraw_title': 'Withdraw the published report?',
  'lr.admin.insp.withdraw_body': 'The public page stops showing it. The report is kept.',
  'lr.admin.insp.publish_title': 'Publish this report?',
  'lr.admin.insp.publish_body': 'It replaces the current public report, if any.',
  'lr.admin.insp.empty': 'No report yet. The public page says "Not inspected yet".',
  'lr.admin.insp.status.draft': 'Draft',
  'lr.admin.insp.status.published': 'Published',
  'lr.admin.insp.status.withdrawn': 'Withdrawn',
  'lr.admin.insp.status.superseded': 'Superseded',
  'lr.admin.insp.score': 'Overall score (1.0 – 5.0)',
  'lr.admin.insp.use_suggested': 'Use the criteria average ({n})',
  'lr.admin.insp.date': 'Inspected on',
  'lr.admin.insp.valid': 'Valid until',
  'lr.admin.insp.funded': 'Paid for by',
  'lr.admin.insp.funded.merchant': 'The merchant',
  'lr.admin.insp.funded.platform': 'The platform',
  'lr.admin.insp.criteria': 'Criteria',
  'lr.admin.insp.criteria.none': 'This category has no criteria yet — set the five under Categories first.',
  'lr.admin.insp.note': 'Inspector note',
  'lr.admin.insp.photos': 'Photos',
  'lr.admin.insp.photos.add': '＋ Add photos',
  'lr.admin.insp.reply': "Owner's reply",
  'lr.admin.insp.save_draft': 'Save draft',
  'lr.admin.insp.cancel': 'Cancel',
  'lr.admin.insp.meta': 'Inspected {date} · valid until {valid} · {funded}',
  'lr.admin.insp.by': 'by {name}',
  'lr.admin.insp.err.score': 'The overall score is a number from 1.0 to 5.0.',
  'lr.admin.insp.err.date': 'The inspection date is required.',
  'lr.admin.insp.err.valid': 'Valid-until must be on or after the inspection date.',
  'lr.admin.insp.err.criteria': 'Score every criterion from 1 to 5.',
  'lr.admin.insp.err.note': 'The note is at most 1000 characters.',
  'lr.admin.insp.err.photos': 'At most eight photos.',
  // ---- Categories › listing extras (API-269) ----
  'lr.admin.catx.menu': 'Listing filters & criteria',
  'lr.admin.catx.title': '{name} — listing filters & criteria',
  'lr.admin.catx.sub': 'What the results page filters on and what reviews and inspections score for this category.',
  'lr.admin.catx.tab.amenities': 'Amenities',
  'lr.admin.catx.tab.filter': 'Filter set',
  'lr.admin.catx.tab.criteria': 'Criteria',
  'lr.admin.catx.am.hint': 'The controlled vocabulary a listing picks from. Removing a key a listing still carries is refused.',
  'lr.admin.catx.am.key': 'Key',
  'lr.admin.catx.am.icon': 'Icon',
  'lr.admin.catx.am.add': '＋ Add amenity',
  'lr.admin.catx.am.saved': 'Amenities saved.',
  'lr.admin.catx.am.in_use': 'Cannot remove: {n} listings still carry a removed amenity.',
  'lr.admin.catx.fs.generic': 'Use the generic filter set',
  'lr.admin.catx.fs.generic_hint': 'Category, City, Specialty, Booking and Good to know, no price bands.',
  'lr.admin.catx.fs.groups': 'Filter groups, in order',
  'lr.admin.catx.fs.up': 'Move up',
  'lr.admin.catx.fs.down': 'Move down',
  'lr.admin.catx.fs.bands': 'Price bands',
  'lr.admin.catx.fs.band_key': 'Key',
  'lr.admin.catx.fs.min': 'From ({unit})',
  'lr.admin.catx.fs.max': 'To ({unit})',
  'lr.admin.catx.fs.add_band': '＋ Add band',
  'lr.admin.catx.fs.saved': 'Filter set saved.',
  'lr.admin.catx.cr.hint': 'Exactly five criteria, or none. Reviews and inspections score each 1–5.',
  'lr.admin.catx.cr.add': '＋ Add criterion',
  'lr.admin.catx.cr.saved': 'Criteria saved.',
  'lr.admin.catx.cr.clear': 'Clear all',
  'lr.admin.catx.group.category': 'Category',
  'lr.admin.catx.group.city': 'City',
  'lr.admin.catx.group.specialty': 'Specialty',
  'lr.admin.catx.group.amenities': 'Amenities',
  'lr.admin.catx.group.booking': 'Booking',
  'lr.admin.catx.group.good_to_know': 'Good to know',
  'lr.admin.catx.group.trust': 'Trust',
  'lr.admin.catx.save': 'Save',
  'lr.admin.catx.failed': 'The change could not be saved.',
  'lr.admin.catx.err.too_many': 'At most forty amenities.',
  'lr.admin.catx.err.key': 'Keys are lowercase letters, digits and underscores (2–40).',
  'lr.admin.catx.err.dupe': 'Keys must be unique.',
  'lr.admin.catx.err.labels': 'Every row needs both labels and an icon.',
  'lr.admin.catx.err.five': 'Set exactly five criteria, or clear them all.',
  'lr.admin.catx.err.groups': 'Pick at least one filter group.',
  'lr.admin.catx.err.bands_max': 'At most eight price bands.',
  'lr.admin.catx.err.band': 'A band needs from < to, and at least one of them.',
  // ---- Businesses › Import CSV (API-268) ----
  'lr.admin.import.button': 'Import CSV',
  'lr.admin.import.title': 'Import listings from CSV',
  'lr.admin.import.sub': 'The same rules as the Data Center import: new rows become unclaimed listings, re-sent rows update them, a claimed listing is left alone, and fields an admin edited stay locked.',
  'lr.admin.import.template': 'Download the template',
  'lr.admin.import.choose': 'Choose a CSV file',
  'lr.admin.import.parsed': '{n} rows read · {ok} ready · {bad} with problems',
  'lr.admin.import.col.line': 'Line',
  'lr.admin.import.col.ref': 'Source ref',
  'lr.admin.import.col.name': 'Name',
  'lr.admin.import.col.category': 'Category',
  'lr.admin.import.col.images': 'Images',
  'lr.admin.import.col.status': 'Status',
  'lr.admin.import.ready': 'Ready',
  'lr.admin.import.problems': 'Problems',
  'lr.admin.import.warnings': 'Warnings',
  'lr.admin.import.send': 'Import {n} listings',
  'lr.admin.import.sending': 'Importing batch {i} of {n}…',
  'lr.admin.import.fetching': 'Reading image {i} of {n}…',
  'lr.admin.import.image_failed': 'Image file not picked, skipped: {url}',
  'lr.admin.import.pick_images': 'Pick the image files',
  'lr.admin.import.pick_images_hint': 'The images column names files by their file name, separated by |. Pick them here before sending; {n} picked.',
  'lr.admin.import.image_big': 'Image over 4 MB skipped: {url}',
  'lr.admin.import.image_type': 'Not a JPEG, PNG or WebP image: {url}',
  'lr.admin.import.done': 'Import finished: {created} created · {updated} updated · {skipped} unchanged (claimed) · {failed} failed',
  'lr.admin.import.batch_failed': 'Batch {i} failed: {detail}',
  'lr.admin.import.col.action': 'Result',
  'lr.admin.import.col.url': 'Page',
  'lr.admin.import.action.created': 'Created',
  'lr.admin.import.action.updated': 'Updated',
  'lr.admin.import.action.unchanged_claimed': 'Unchanged (claimed)',
  'lr.admin.import.action.failed': 'Failed',
  'lr.admin.import.locked': 'Locked fields skipped: {fields}',
  'lr.admin.import.export': 'Export results CSV',
  'lr.admin.import.reset': 'Start over',
  'lr.admin.import.nothing': 'No ready rows to import.',
  'lr.admin.import.empty': 'The file has no data rows.',
  'lr.admin.import.close': 'Close',
  // ---- Businesses list columns / filters ----
  'lr.admin.list.col.listing': 'Listing',
  'lr.admin.list.col.listing_title': 'Claim state and how complete the public profile is',
  'lr.admin.list.details': '{n} of 5 on file',
  'lr.admin.list.filter.claim': 'Claim',
  'lr.admin.list.claim.unclaimed': 'Unclaimed',
  'lr.admin.list.claim.claim_under_review': 'Claim under review',
  'lr.admin.list.claim.claimed': 'Claimed',
  'lr.admin.list.claim.claimed_verified': 'Claimed & verified',
  'lr.admin.list.sort.details': 'Details on file',
  // ---- shared ----
  'lr.admin.common.cancel': 'Cancel',
  'lr.admin.common.remove': 'Remove',
  'lr.admin.common.unknown': 'Unknown',
} as const satisfies Record<string, string>;
